module.exports = __webpack_public_path__ + "images/旅悦好物全景_02-3.jpg?v=11ed0ce7";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/lvyue3/旅悦好物全景_02-3.jpg
 ** module id = 130
 ** module chunks = 1 2
 **/